import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';

export default ContentCopyRoundedIcon;
